import React, { Fragment, useState } from 'react';
//import history from '../../../';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import Delete from '@material-ui/icons/DeleteOutline';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CloseIcon from '@material-ui/icons/Close';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import ModalAlert from '../../../../shared/components/Modal';
import Modal from '@material-ui/core/Modal';
import ModalMat from '@material-ui/core/Modal';
import RepeatIcon from '@material-ui/icons/Repeat';
import moment from 'moment';
import MomentUtils from '@date-io/moment';
import ImageIcon from '@material-ui/icons/Image';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";

const ReactTableActionsAsignAdvance = ({ data, refresh, onSelectednvoice, totalAdvancedPayment }) => {

    const [isDelete, setIsdeleted] = useState(false);
    const [showAdvancePDF, setShowAdvancePDF] = useState(false);
    const [showFormAddPaymentsToInvoice, setShowFormAddPaymentsToInvoice] = useState(false);
    const urlLogo = sessionStorage.getItem('logoURL');
    const profile = JSON.parse(sessionStorage.getItem('clinica'));
    const user = JSON.parse(sessionStorage.getItem('usuario'));

    const onToggleSelectedInvoice = (invoice) => {
        console.log('invoice', invoice);
        onSelectednvoice(invoice);
    }
    return (<Fragment>
        <td role="cell">

            <Tooltip title="Adicionar">
                <IconButton aria-label="edit" 
                disabled={totalAdvancedPayment?.left <= 0 ? true : false}
                onClick={() => {
                    //onToggleToEditAdvance(data.data.original);
                    onToggleSelectedInvoice(data.data.original);
                }}>
                    <FontAwesomeIcon icon={faPlus} />
                    {/* <EditOutlinedIcon /> */}
                </IconButton>
            </Tooltip>
            {/* <Tooltip title="Asignar Anticipo a Facturas">
                <IconButton aria-label="edit" onClick={() => {
                    //onToggleToEditAdvance(data.data.original)
                    setShowFormAddPaymentsToInvoice(true);
                }}>
                    <FontAwesomeIcon icon={faHandHoldingDollar} />
                </IconButton>
            </Tooltip>
            <Tooltip title="Ver PDF">
                <IconButton
                    aria-label="edit"
                    onClick={() => {
                        printPDFAdvance(data.data.original);
                    }}>
                    <FontAwesomeIcon icon={faFilePdf} />
                </IconButton>
            </Tooltip>
            <Tooltip title="">
                <IconButton aria-label="delete" onClick={() => {
                    setIsdeleted(true);
                }}>
                    <DeleteForeverIcon />
                </IconButton>
            </Tooltip> */}
            {isDelete ?
                <ModalAlert
                    color={'warning'}
                    title={"Seguro"}
                    message={"¿Deseas eliminar este Anticipo?"}
                    modal={isDelete}
                    onOk={onDelet}
                    toggle={() => { setIsdeleted(!isDelete) }}
                />
                : null}
        </td>
        {/* {showAdvancePDF ?
            <Modal
                open={showAdvancePDF}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '80%', margin: 10, height: '80%' }}>
                    <IconButton style={{ float: 'right' }} onClick={() => {
                        setShowAdvancePDF(false);
                    }}>
                        <CloseIcon />
                    </IconButton>
                    <iframe id="pdfV" width="100%" height="90%" title="pdf-report" >
                    </iframe>
                </div>
            </Modal>
            : null} */}
          
    </Fragment>)
}

export default ReactTableActionsAsignAdvance;